var ɵ0 = {};
var AppModule = /** @class */ (function () {
    function AppModule() {
    }
    return AppModule;
}());
export { AppModule };
export { ɵ0 };



// WEBPACK FOOTER //
// ./src/app/app.module.ts.pre-build-optimizer.js